import {create} from 'zustand';
import {createSelectors} from './zustand';

interface NodeNameEditState {
    editingName: boolean;
    editingNodeNameId: string;
    setEditingName: (editingName: boolean) => void;
    setEditingNodeNameId: (editingNodeNameId: string) => void;
    startEditing: (editingNodeNameId: string) => void;
    stopEditingAndSaveNodeId: () => void;
    stopEditing: () => void;
}

export const useNodeNameEditStoreBase = create<NodeNameEditState>()((set) => ({
    editingName: false,
    editingNodeNameId: '',
    setEditingNodeNameId: (editingNodeNameId) => set(() => ({editingNodeNameId})),
    setEditingName: (editingName) => set(() => ({editingName})),
    startEditing: (editingNodeNameId) => set(() => ({editingName: true, editingNodeNameId})),
    stopEditing: () => set(() => ({editingName: false, editingNodeNameId: ''})),
    stopEditingAndSaveNodeId: () => set(() => ({editingName: false})),
}));

export const useNodeNameEditStore = createSelectors(useNodeNameEditStoreBase);
